import { render, staticRenderFns } from "./recheck.vue?vue&type=template&id=16dea082&scoped=true&"
import script from "./recheck.vue?vue&type=script&lang=js&"
export * from "./recheck.vue?vue&type=script&lang=js&"
import style0 from "./recheck.vue?vue&type=style&index=0&id=16dea082&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dea082",
  null
  
)

export default component.exports